import { useCallback } from 'react';
import {
  useQuery,
  useSuspenseQuery,
  QueryResult,
  useLazyQuery,
  useApolloClient,
  QueryOptions,
  QueryHookOptions,
  SuspenseQueryHookOptions,
  LazyQueryHookOptions,
  LazyQueryExecFunction
} from '@apollo/client';
import { useSnackbarHelper } from '../../useSnackbarHelper';
import QUERY from '../operations/EngagementCampaignTrafficSource.graphql';
import { Query, QueryengagementCampaignTrafficSourceArgs } from '../../__generated__/globalTypes';

export const useEngagementCampaignTrafficSourceQuery = (
  options?: QueryHookOptions<Query, QueryengagementCampaignTrafficSourceArgs>
) => {
  const { t, enqueueSnackbar } = useSnackbarHelper();
  const result = useQuery<Query, QueryengagementCampaignTrafficSourceArgs>(QUERY, {
    onError: (error) => {
      enqueueSnackbar(t(error.message), { variant: 'error' });
    },
    ...options
  });

  return result;
};

export const useEngagementCampaignTrafficSourceLazyQuery = (
  options?: LazyQueryHookOptions<Query, QueryengagementCampaignTrafficSourceArgs>
): QueryResult<Query, QueryengagementCampaignTrafficSourceArgs> & {
  getEngagementCampaignTrafficSource: LazyQueryExecFunction<Query, QueryengagementCampaignTrafficSourceArgs>;
} => {
  const { t, enqueueSnackbar } = useSnackbarHelper();
  const [getEngagementCampaignTrafficSource, result] = useLazyQuery<Query, QueryengagementCampaignTrafficSourceArgs>(
    QUERY,
    {
      onError: (error) => {
        enqueueSnackbar(t(error.message), { variant: 'error' });
      },
      ...options
    }
  );

  return { getEngagementCampaignTrafficSource, ...result };
};

export const useEngagementCampaignTrafficSourcePromiseQuery = () => {
  const client = useApolloClient();

  const getEngagementCampaignTrafficSource = useCallback(
    (options?: Omit<QueryOptions<QueryengagementCampaignTrafficSourceArgs, Query>, 'query'>) =>
      client.query<Query, QueryengagementCampaignTrafficSourceArgs>({ ...options, query: QUERY }),
    [client]
  );

  return { getEngagementCampaignTrafficSource };
};
// Suspense Query Hooks
export const useEngagementCampaignTrafficSourceSuspenseQuery = (
  options?: SuspenseQueryHookOptions<Query, QueryengagementCampaignTrafficSourceArgs>
) => {
  const result = useSuspenseQuery<Query, QueryengagementCampaignTrafficSourceArgs>(QUERY, {
    ...options
  });

  return result;
};
